import Vue from 'vue'

import filters from './global.js'
Vue.use(filters);

import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter,{
	symbol : '$',
	thousandsSeparator: ',',
	fractionCount: 2,
	fractionSeparator: '.',
	symbolPosition: 'front',
	symbolSpacing: false
})